const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class SetBuilder extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()

    if (!this.els?.info?.exists) return
    this.infoCarousel = this.setupInfoCarousel()
  }

  setupListeners () {
    super.setupListeners()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        mode: 'snap',
        drag: true,
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2,
              spacing: 0,
              origin: 'center',
            },
          },
          '(min-width: 900px)': {
            slides: {
              perView: 2.9,
              spacing: 0,
              origin: 'center',
            },
          },
        },
        slideChanged: this.onSlideChanged,
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onSlideChanged (instance) {
    if (!this.els?.form?.exists) return

    const currentSlide = instance.track.details.rel

    this.els.form.elements.forEach((form, index) => {
      form.setAttribute('aria-current', index === currentSlide)
    })
    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-current', index === currentSlide)
    })
  }

  setupInfoCarousel () {
    return new window.KeenSlider(
      this.els.info.element,
      {
        selector: this.els.form.selector,
        loop: true,
        mode: 'snap',
        drag: false,
        slides: {
          perView: 1,
          spacing: 0,
          origin: 'center',
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('set-builder')) {
  customElements.define('set-builder', SetBuilder)
}
